var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 28,
    viewBox: "0 0 87 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5024 4.74181H30.1288L33.0248 16.2746C33.0248 16.2746 33.3389 17.6051 33.4691 18.2589C33.5994 17.6077 33.9135 16.2491 33.9135 16.2491L36.8886 4.74181H40.4383L43.4135 16.2491C43.4135 16.2491 43.7276 17.6051 43.8578 18.2589C43.9881 17.6077 44.3022 16.2746 44.3022 16.2746L47.1982 4.74181H50.8245L45.7885 23.0063H42.083L38.666 9.75229L35.2491 23.0063H31.5436L26.5024 4.74181Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2057 10.0639H52.919V23.0064H56.2057V10.0639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4349 23.0063V15.5442C68.4349 13.8485 67.6253 12.7785 65.7994 12.7785C64.0782 12.7785 62.7987 14.2648 62.7987 16.4304V23.0063H59.512V10.0639H62.7987V12.1503C63.764 10.664 65.304 9.69867 67.181 9.69867C69.9467 9.69867 71.7216 11.4991 71.7216 14.1856V23.0038H68.4349V23.0063Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6743 4.74181H77.9609V13.9788L81.9014 10.0639H85.9721L81.2502 14.6811L86.6003 23.0038H82.8157L78.9544 16.9514L77.9635 17.9167V23.0038H74.6768V4.74181H74.6743Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4821 3.40622L53.7666 4.69076L52.4821 5.9753L54.0016 7.49224L56.8031 4.69076L54.0016 1.88928L52.4821 3.40622Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76567 0.428589L0.428711 7.76555L6.6369 13.9737L0.428711 20.1845L7.76567 27.5215L21.3134 13.9737L7.76567 0.428589Z",
    fill: "#ff3f2a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7283b35f8ccddd845742b4ff283ebb7.svg";
export { ForwardRef as ReactComponent };